import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    category: string;
    list_no: string;
}

interface RequestBody {
    name: string;
    subject: string;
    contents: string;
    notice: number;
    b_file: File[];
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: RequestBody) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof RequestBody];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePutConsoleNotice = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();
    const headers = {
        "Content-Type": "multipart/form-data",
    };

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_notice.replace(":category", updateData.category).replace(":list_no", updateData.list_no);
            const formData = createFormData({
                name: updateData.name,
                subject: updateData.subject,
                contents: updateData.contents,
                notice: updateData.notice,
                b_file: updateData.b_file,
            });
            try {
                const response = await axiosInstance.put(url, formData, { headers });
                return response.data.data;
            } catch (error: any) {
                // 백엔드 안내 메시지(예: 파일 용량 초과)를 그대로 노출
                throw new Error(error?.response?.data?.message || error?.message || "수정에 실패했습니다.");
            }
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleNoticeDetail"] });
            successCallback?.(data);
        },
    });
};
